module.exports = __webpack_public_path__ + "media/images/crm/content-illustration-4-aede8d8391a48ba33fe0fa9917b9eb2a.png";